import { GEN_1_DEVICES, PROTOTYPES } from 'src/constants';

// Regex to match Bluetooth devices that support one-click pairing.
export const BLU_DEVICES_WITH_ONE_CLICK_PAIRING = /^(SBWS-90CM)$/;

export const CUSTOM_INCLUSION_LIST_FOR_WEB_BT = [
	{
		id: 'SBBT-002|Shelly Blue Button|Shelly Ble Button',
		name: 'Shelly BLU Button',
		image: 'images/device_images/SBBT-002C.png',
		deviceType: 'SBBT-002C',
	},
	{
		id: 'SBBT-102',
		name: 'Shelly BLU Button ZB',
		image: 'images/device_images/SBBT-102C.png',
		deviceType: 'SBBT-102C',
	},
	{
		id: 'SBBT-102CEU|BLU Wall Switch 2 ZB',
		name: 'Shelly BLU Wall Switch 2 ZB',
		image: 'images/device_images/SBBT-102CEU.png',
		deviceType: 'SBBT-102CEU',
	},
	{
		id: 'SBBT-004',
		name: 'Shelly BLU Button 4',
		image: 'images/device_images/SBBT-004CUS.png',
		deviceType: 'SBBT-004CUS',
	},
	{
		id: 'SBBT-104',
		name: 'Shelly BLU Button 4 ZB',
		image: 'images/device_images/SBBT-004CUS.png',
		deviceType: 'SBBT-104CUS',
	},
	{
		id: 'SBDW-0|Shelly BLE DW',
		name: 'Shelly BLU Door Window',
		image: 'images/device_images/SBDW-002C.png',
		deviceType: 'SBDW-002C',
	},
	{
		id: 'SBDW-1',
		name: 'Shelly BLU Door Window ZB',
		image: 'images/device_images/SBDW-103C.png',
		deviceType: 'SBDW-103C',
	},
	{
		id: 'SBDW-2',
		name: 'Shelly BLU Door Window Mini ZB',
		image: 'images/device_images/SBDW-203C.png',
		deviceType: 'SBDW-203C',
	},
	{
		id: 'SBDW-3',
		name: 'Shelly BLU Door Window Outdoor ZB',
		image: 'images/device_images/SBDW-302C.png',
		deviceType: 'SBDW-302C',
	},
	{
		id: 'SBHT-0',
		name: 'Shelly BLU H&T',
		image: 'images/device_images/SBHT-003C.png',
		deviceType: 'SBHT-003C',
	},
	{
		id: 'SBHT-1',
		name: 'Shelly BLU H&T Display ZB',
		image: 'images/device_images/SBHT-103C.png',
		deviceType: 'SBHT-103C',
	},
	{
		id: 'SBHT-2|BLU H&T',
		name: 'Shelly BLU H&T ZB',
		image: 'images/device_images/SBHT-003C.png',
		deviceType: 'SBHT-203C',
	},
	{
		id: 'SBMO-0',
		name: 'Shelly BLU Motion',
		image: 'images/device_images/SBMO-003Z.png',
		deviceType: 'SBMO-003Z',
	},
	{
		id: 'SBMO-1',
		name: 'Shelly BLU Motion ZB',
		image: 'images/device_images/SBMO-103Z.png',
		deviceType: 'SBMO-103Z',
	},
	{
		id: 'SBDS',
		name: 'Shelly BLU Distance',
		image: 'images/device_images/SBDS-002A.png',
		deviceType: 'SBDS-002A',
	},
	{
		id: 'SBDI',
		name: 'Shelly BLU Distance 2',
		image: 'images/device_images/SBDI-003E.png',
		deviceType: 'SBDI-003E',
	},
	{
		id: 'WallDisplay',
		name: 'Shelly WallDisplay',
		image: 'images/device_images/SAWD-0A1XX10EU1.png',
		deviceType: 'SAWD-0A1XX10EU1',
	},
	{
		// XMOD advertises with names like "AppTeamXmodV1-XXXXXXXXXXXX"
		// Use multiple prefixes so Web Bluetooth scanning can match it reliably.
		id: 'AppTeamXmod|Xmod|App|appteamxmodv1|S3MX-0A|Shelly XMOD|XMOD',
		name: 'Shelly XMOD',
		image: 'images/device_images/S3MX-0A.png',
		deviceType: 'S3MX-0A',
	},
	{
		id: 'SBWS',
		name: 'Shelly Weather Station',
		image: 'images/device_images/SBWS-90CM.png',
		deviceType: 'SBWS-90CM',
	},
	{
		id: 'SBRC',
		name: 'Shelly BLU Remote Controller',
		image: 'images/device_images/SBRC-005B.png',
		deviceType: 'SBRC-005B',
	},
	{
		id: 'SBRK',
		name: 'Shelly BLU Rotary Knob ZB',
		image: 'images/device_images/SBRK-002C.png',
		deviceType: 'SBRK-002C',
	},
	{
		id: 'SBSM',
		name: 'Shelly Smoke LTE',
		image: 'images/device_images/SBSM-0031ZL.png',
		deviceType: 'SBSM-0031ZL',
	},
	{
		id: 'SBMS',
		name: 'Shelly BLU Soil',
		image: 'images/device_images/SBMS-001A.png',
	},
];

const EXCLUDE_DEVICES_FROM_WEB_BT_INCLUSION = [
	// BLU devices, Shelly Modules and Wall Display are hidden from the standard
	// inclusion list and are available through a custom inclusion list.
	'SBBT-002C', // BLU Button
	'SBBT-102C', // BLU Button Tough 1 ZB
	'SBBT-102CEU', // BLU Wall Switch 2 ZB
	'SBHT-003C', // BLU H&T
	'SBHT-103C', // BLU H&T display https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2846
	'SBHT-203C', // BLU H&T ZB
	'SBDW-002C', // BLU Door Window
	'SBDW-103C', // BLU Door Window ZB
	'SBDW-203C', // BLU Door Window Mini ZB
	'SBDW-302C', // BLU Door Window Outdoor ZB
	'SBDS-002A', // BLU Distance
	'SBDI-003E', // Blu Distance 2
	'SBMO-003Z', // BLU Motion
	'SBMO-103Z', // BLU Motion ZB
	'SBBT-004C', // BLU Button 4
	'SBBT-004CUS', // BLU Button 4
	'SBBT-004CEU', // BLU Button 4
	'SBBT-104CUS', // BLU Button 4 ZB
	'SBBT-104CEU', // BLU Button 4 ZB
	'S3MX-0A', // Shelly X Module
	'S3XT-0S', // Shelly XT1 Module
	'SBWS-90CM', // Shelly Weather Station
	'SAWD-0A1XX10EU1', //ShellyWallDisplay
	'SAWD-1A1XX10EU1', //ShellyWallDisplay
	'SAWD-2A1XX10EU1', //ShellyWallDisplayX2
	'SAWD-3A2XE10EU2', //ShellyWallDisplayXL old model
	'SAWD-3A1XE10EU2', //ShellyWallDisplayXL new model
	'SAWD-4A1XE10US0', //ShellyWallDisplayXL US
	'SAWD-5A1XX10EU0', //ShellyWallDisplayXL X2 Smatek
	'SAWD-6A1XX10EU0', //ShellyWallDisplayX1i
	'SAWD-6A0XX0EU0', //ShellyWallDisplay D1
	'SBRC-005B', //Shelly BLU Remote Controller
	'SBRK-002C', //Shelly BLU Rotary Knob ZB
	'peripheral-device', //Peripheral Device
	'virtual-group', //Virtual Device
	'bthome-device', //BTHome Device

	// Test Devices
	'SNSL-0A2X03WWL', // ShellyPlus2L
	'SNDM-9995WW', // Plus Dimmer TEST
	'SNGW-ZW01', // ShellyWaveGw
	'S3GW-1DZW0EU', // ShellyWaveGw
	'SBTR-001AEU', // blue trv can not be added - https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1793//shelly em mini gen4 https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2045
	'SNSW-002X16EU', //Shelly Plus 2
	'SNSL-0A1X03WWL', // Shelly Plus 1L
	'SPCB-01VENEU', // shelly pro cb
	'SPCB-02VENEU', // shelly pro cb
	'SPCB-03VENEU', // shelly pro cb
	'SPCB-04VENEU', // shelly pro cb https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/1996
	'S3GW-0D4G0EU', // Shelly 4G Gateway https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2049
	'LOQED', // Loqed
	'S4SW-0A1X1EUL', // Shelly 1L Gen4 https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2392
	'S4SW-0A2X4EUL', // Shelly 2L Gen4 https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2153
	'S3SW-001P16SP', //Simone 1PM
	'S3BL-D010009AEU', // Duo Bulb G3
	// 'S4PB-0916176901', // MMotors Ventora
	'S3SN-0082A', // Alarm Bridge
	'S3SW-0A1X5US', // Wall switch Single Pole
	'S4SN-0A61X', // Presence C Gen4
	'SBMS-001A', // BLU Soil

	//Excluded as https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2728
	// 'S3BL-C010007AEU', // V-TAC RGB CCT Bulb
	'SMSN-0031ZL', //Smoke LTE
	'SBMS-001A', // Shelly BLU Soil

	//Camera devices
	'SACM-0A0XX0EU0', //Shelly Camera Android
	'S1CM-0DXW00', //Shelly Camera
	'S3PB-0a15194101',
];

export const EXCLUDE_FROM_WEB_BT_INCLUSION = [
	...GEN_1_DEVICES,
	...PROTOTYPES,
	...EXCLUDE_DEVICES_FROM_WEB_BT_INCLUSION,
];
